import React, { createContext, useContext, useState, useMemo } from 'react';

const LoadingContext = createContext({
  loading: false,
  setLoading: () => {},
});

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const value = useMemo(() => ({ loading, setLoading }), [loading]); // Memoize value
  return (
    <LoadingContext.Provider value={value}>
      {children}
      {loading && (
        // <div style={{
        //     position: 'fixed',
        //     top: '50%',
        //     left: '50%',
        //     transform: 'translate(-50%, -50%)',
        //     zIndex: 1000,
        // }}>
        //     <div className="spinner">Loading...</div>
        <span className="loader"></span>

        // </div>
      )}
    </LoadingContext.Provider>
  );
};

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
}
